var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_999_1103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_999_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6375 12.25C10.4222 12.25 9.22153 11.9851 8.03542 11.4552C6.84931 10.9253 5.77014 10.1743 4.79792 9.20208C3.82569 8.22986 3.07465 7.15069 2.54479 5.96458C2.01493 4.77847 1.75 3.57778 1.75 2.3625C1.75 2.1875 1.80833 2.04167 1.925 1.925C2.04167 1.80833 2.1875 1.75 2.3625 1.75H4.725C4.86111 1.75 4.98264 1.79618 5.08958 1.88854C5.19653 1.9809 5.25972 2.09028 5.27917 2.21667L5.65833 4.25833C5.67778 4.41389 5.67292 4.54514 5.64375 4.65208C5.61458 4.75903 5.56111 4.85139 5.48333 4.92917L4.06875 6.35833C4.26319 6.71806 4.4941 7.06562 4.76146 7.40104C5.02882 7.73646 5.32292 8.05972 5.64375 8.37083C5.94514 8.67222 6.26111 8.95174 6.59167 9.20937C6.92222 9.46701 7.27222 9.70278 7.64167 9.91667L9.0125 8.54583C9.1 8.45833 9.21424 8.39271 9.35521 8.34896C9.49618 8.30521 9.63472 8.29306 9.77083 8.3125L11.7833 8.72083C11.9194 8.75972 12.0312 8.83021 12.1187 8.93229C12.2062 9.03437 12.25 9.14861 12.25 9.275V11.6375C12.25 11.8125 12.1917 11.9583 12.075 12.075C11.9583 12.1917 11.8125 12.25 11.6375 12.25Z",
    fill: "#07AA3F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2f665c24238c7e5b165c3d040fbf92af.svg";
export { ForwardRef as ReactComponent };